"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  userCenter: {
    desktop: '个人工作台',
    center: '个人中心',
    await: '待办事项',
    authApprove: '授权审批',
    attentionBuz: '我的收藏',
    attentionShip: '关注船舶',
    followed: '关注',
    unFollowed: '未关注',
    vesselList: '船舶列表',
    authTable: {
      authorizer: '授权人',
      authorized: '被授权人',
      startTime: '授权开始时间',
      endTime: '授权结束时间',
      module: '功能模块'
    },
    taskType: '待办分类',
    emergency: '紧急程度',
    awaitTable: {
      publishTime: '日期',
      modelName: '待办分类',
      currNodeStatus: '紧急程度',
      activityName: '待办名称',
      remark: '备注',
      toDoDate: '待办日期',
      handleType: '处理类型',
      handleDate: '处理时间',
      handleOpinion: '处理意见'
    },
    transferDialog: {
      publishTime: '发布日期',
      modelName: '待办名称',
      activityName: '节点名称',
      executionId: '实例ID',
      msgKey: '业务流程唯一ID',
      payload: '提交内容',
      selectUserTile: '转办人选择',
      selectFromUserTile: '待办转移',
      operationTips: '操作提示'
    },
    buzTable: {
      ship: '船舶',
      buzModule: '业务模块',
      featureInterface: '功能界面',
      businessPaper: '业务摘要',
      attentionTime: '收藏时间'
    },
    vesselDashboard: '单船画像(建设中)',
    vesselFilter: {
      company: '公司',
      vesselTeam: '船队',
      vesselCode: '船舶代码',
      isFocus: '是否关注',
      vesselName: '船名',
      manager: '管理人'
    },
    vesselTable: {
      company: '公司',
      vesselTeam: '船队',
      vesselCode: '船舶代码',
      vesselName: '船舶名称'
    },
    msgList: '待阅提醒',
    msgRead: '消息待阅',
    monitorRemind: '监控提醒',
    msgFilter: {
      messageMode: '消息模块',
      messageSubType: '消息子类型',
      msgType: '消息类型',
      readFlag: '是否已读'
    },
    msgTable: {
      messageType: '消息类型',
      messageSubject: '主题',
      messageMode: '消息模块',
      msgContent: '消息提醒内容',
      messageSubType: '消息子类型',
      creator: '通过用户',
      creatorTime: '发布日期',
      readTime: '已读日期',
      readFlag: '是否已读',
      read: '已读',
      noRead: '未读'
    },
    vesselDynamic: {
      title: '船舶动态',
      status: '航行状态',
      destination: '目的地',
      logLat: '经纬度',
      long: '船长',
      wide: '船宽',
      etaTime: '预抵时间',
      sailing: '在航',
      port: '宁波港',
      speed: '航速',
      azimuth: '航向'
    },
    crewList: {
      title: '船员列表',
      crewName: '船员姓名',
      position: '职位',
      onBoardDate: '上船日期',
      serviceLog: '服务日志',
      operation: '操作'
    },
    budget: {
      title: '预算执行情况'
    },
    notCorrected: {
      title: '未整改NC数量'
    },
    outDate: {
      title: '已过期及三个月内过期的证书',
      dept: '部门',
      liscence: '证书',
      outDate: '过期时间'
    },
    exercise: {
      title: '应急演习计划执行进展'
    },
    workOrder: {
      title: '工单过期情况'
    },
    building: '功能建设中...',
    authApproval: {
      authorizer: '授权人',
      authorizered: '被授权人',
      authorizerTime: '授权时间',
      currentStatus: '当前状态',
      authorizerRole: '授权角色',
      authorizerModel: '授权模块',
      authorizeredRole: '被授权人角色',
      startTime: '授权开始时间',
      endTime: '授权结束时间',
      remark: '备注',
      taskCompletedNumber: '授权已办数',
      terminationTime: '终止时间',
      terminationPeople: '终止人',
      authorizeDetail: '授权审批详情',
      authorizeResource: '授权权限选择',
      choosedModel: '已选择模块',
      authorizedChoose: '被授权人选择',
      role: '岗位角色',
      chooseAuthorized: '选择被授权人',
      no: '序号',
      account: '账号',
      nameCn: '中文名',
      nameEn: '英文名',
      choosedUser: '已选择人员',
      authorizeBaseInfo: '授权基本信息',
      authorizeDate: '授权日期',
      to: '至',
      authorizeStatus: '授权状态',
      invalidAuthorizeTip: '是否终止本次权限授权？',
      invalidSuccess: '终止成功',
      plsChooseAuthorizeModel: '请选择授权模块',
      plsChooseAuthorized: '请选择被授权人',
      authorizedCanNotSelf: '被授权人不可为自己',
      dealType: '处理类型',
      dealTime: '处理时间',
      dealOpinion: '处理意见',
      showFile: '查看附件',
      taskCompleted: '授权已办',
      clickToGoTaskCompleted: '点击进入授权已办列表',
      nodeClickTip: '已保存的授权审批不可切换授权角色'
    },
    fileReport: {
      dailySummary: '每日调度会纪要',
      weeklyReport: '市场及营运周报',
      monthlyRepot: '航运经济信息月报'
    },
    userInfo: {
      accountNameISNull: '用户名不为空',
      accountNameExist: '用户名已存在',
      baseInfoTitle: '基础信息',
      accountInfo: '登录账号',
      userName: '用户名',
      activateEmail: '激活邮箱',
      notifyToEmail: '业务通知发送邮箱',
      notifyCcEmail: '业务通知抄送邮箱',
      bookingViewType: '我的订舱列表视图',
      cardRadio: '卡片视图',
      listRadio: '列表视图',
      passwordInfoTitle: '密码管理',
      passwordInfo: '密码',
      confirmPassword: '确认密码',
      successMessage: '用户信息修改成功',
      passwordRules: '请输入密码',
      passwordRules1: '密码，8<=密码长度<=30，必须包含大写字母+小写字母+数字+特殊符号（!@#￥%&）',
      passwordRules2: '密码中不能出现特殊字符如<> ‘ “ : | ? * \\ /',
      confirmPasswordRules: '请输入二次确认密码',
      errorPasswordRules: '两次密码校验不一致',
      emailCheckRules: '业务通知发送邮箱不能为空!',
      emailCheckRules1: '邮箱格式的最大长度不得超过500',
      emailCheckRules2: '请输入正确的邮箱格式,多个邮箱用英文分号连接',
      submitButton: '提交',
      simisCompanyCode: '公司代码',
      simisCompanyNameCn: '公司中文名称',
      simisCompanyNameEn: '公司英文名称'
    },
    billConsigneeApplication: {
      addButton: '新增',
      editButton: '编辑',
      deleteButton: '删除',
      submitButton: '提交',
      searchButton: '查询',
      resetButton: '重置',
      cancelSubmitButton: '取消提交',
      NoTable: 'NO.',
      portTable: '港口',
      companyName: '公司名称',
      companyNameCN: '公司名称(CN)',
      usciTable: 'USCI',
      confirmBookTable: '承诺书',
      statusTable: '状态',
      addDialogText: '新增',
      editDialogText: '编辑',
      operationTable: '操作',
      addSuccess: '新增成功',
      editSuccess: '修改成功',
      deleteConfirm: '确认删除该数据?',
      deleteMessage: '删除成功',
      confirmMessage: '提交成功',
      cancenConfirmMessage: '取消提交成功',
      lockSuccess: '锁定成功',
      unLockSuccess: '解锁成功',
      confirmButton: '确认',
      cancelButton: '取消',
      isCancenSubmitText: '只有待审核状态的记录可以取消提交',
      isEditText: '只有待提交和取消审核状态可以编辑',
      isSelectData: '请先勾选表格数据',
      isCancelDelText: '只有待提交和取消审核状态可以删除',
      isCancelDelText2: '存在不是【待提交】、【取消审核】的记录，请重新勾选！',
      isConfirmText: '存在不是【待提交】的记录，请重新勾选！',
      isCancenSubmitText2: '存在不是【待审核】的记录，请重新勾选！'
    },
    editFormDialog: {
      saveButton: '保存',
      cancelButton: '取消',
      portFormItem: '港口:',
      operationFormItem: '公司名称:',
      operationFormItemCn: '公司名称(CN):',
      USCI: 'USCI/TIN:',
      portCodeRule: '请输入港口',
      companyNameRule: '请输入公司名称',
      companyNameCnRule: '请输入公司名称(CN)',
      usciRule: '请输入USCI'
    },
    childrenUserManage: {
      isAddFive: '新增子账号不能超过10条',
      accountFormItem: '账号',
      userNameFormItem: '用户名',
      resetButton: '重置',
      searchButton: '查询',
      addChildrenUserButton: '新增子账号',
      addChildrenUserInfo: '最多只能创建5个子账号，包括锁定的账号，不包括删除的账号',
      accountTable: '账号',
      userNameTable: '用户名',
      activateTable: '激活状态',
      lockTable: '锁定状态',
      lastLoginTimeTable: '最近登录时间',
      operationTable: '操作',
      portAndSysemTitle: '港口权限+设置',
      addPortAndUserButton: '添加港口权限+角色',
      roleTypePortTable: '权限类型',
      portName: '港口',
      officeAbbrev: '机构',
      portAndOutfitPortTable: '角色/港口/机构',
      timePortTable: '分配时间',
      activatePortTable: '操作',
      accountDialog: '账号',
      userNameDialog: '用户名',
      passwordDialog: '密码',
      confirmPassword: '确认密码',
      editDialogText: '编辑',
      addDialogText: '新增',
      addChildrenSuccess: '新增港口+角色成功',
      addChildrenError: '新增港口+角色失败',
      resetSuccess: '重置密码成功,密码为：',
      isNotChildren: '子账号不能再申请子账号',
      addDialogRole: '角色',
      addDialogPort: '港口',
      addDialogOrganization: '机构',
      accountType: '账号类型',
      tableNo: '序号',
      selectWarning: '请先选中表格数据',
      roleNameCn: '角色中文名',
      roleNameEn: '英文名',
      locked: '锁定',
      unLocked: '解锁',
      resetPasswprd: '重置密码',
      activateEmail: '激活邮箱'
    },
    dangerousDeclaration: {
      searchButton: '查询',
      billNumber: '提单号',
      shipNameVoyage: '船名航次',
      timeInquiryButton: '截单时间查询',
      cutTime: '截单时间',
      searchTitle: '查询结果',
      goodsTickets: '货申报票数',
      paperUploadButton: '上传纸面申报',
      shipWarningInfo: '请正确输入船名、航次、提单号后上传纸面申报',
      copyWarningInfo: '已申请：收到货申报EDI；已受理：收到货申报EDI，且收到电子装箱单信息',
      cargoDeclarationReceiptNumber: '货申报回执号',
      hazardousDeclarationPaper: '危申报纸面',
      acceptanceMark: '受理标志',
      lockStatus: '锁定状态',
      remarks: '备注',
      delayTime: '由于已经超过申报截止时间，请电话与我司联系',
      uploadButton: '上传',
      closeButton: '关闭',
      noClickDataWarning: '请先选中表格数据',
      blNoWarning: 'blNo为空',
      noDataWarning: '请先选择列表的记录',
      doucmentCutTimeDataWarning: '请先查询截单时间',
      isDelayTimeWarning: '已超出截单范围日期',
      uploadSuccess: '上传成功',
      vesselWarning: '请填写正确的船名航次、提单号',
      searchFormDocumentWarning: '请选择船名航次',
      searchBlNoWarning: '提单号不能为空'
    },
    newManifestEDI: {
      shipVoyageName: '船名航次',
      prewiredLock: '预配锁',
      whetherToSendLoad: '装载成功',
      whetherToSendSuccess: '装载成功',
      billNumber: '提单号',
      whetherToSendPreconfigured: '发送预配',
      filterSuborder: '过滤分单',
      actualBoxBolume: '实际箱量',
      releasedOrNot: '已放行',
      portOfLoading: '装货港',
      beforeSplitting: '拆并单前',
      afterSplitting: '拆并单后',
      searchButton: '查询',
      resetButton: '重置',
      exportEdiButton: 'EDI发送',
      prewired: '预配',
      pass: '放行',
      stow: '装载',
      masterListNumber: '总单号',
      bookingNumber: '订舱号',
      timeOfShipment: '装船时间',
      preAllocatedSendingTime: '预配发送时间',
      clearanceTime: '放行时间',
      LoadSendingTime: '装载发送时间',
      WhetherToLoadOvertime: '装载超时间',
      boxVolume: '箱型箱量',
      privilegeCode: '关别代码',
      placeOfOriginArrival: '起/抵运地',
      placeOfLoading: '装货地点',
      placeOfLoadingCode: '装货港代码',
      EDIFileType: 'EDI报文类型',
      chooseEdi: '选择EDI',
      descriptionReasonChange: '变更原因描述',
      changeRequestContactName: '变更申请联系人姓名',
      changeRequestContactPhone: '变更申请联系人电话',
      fileTypeListForm: '报文类型',
      changeOfManifestReason: '更改舱单原因',
      isSelectFileType: '请先选择EDI报文类型',
      ediSuccess: '操作成功',
      pol: '装货港',
      vvl: '船名航次',
      inputVvl: '请输入船名航次',
      inputPol: '请输入装货港',
      inputCustomsId: '请输入关别代码',
      inputDistrictCode: '请输入起/抵运港',
      inputLoadPlace: '请输入装货地点',
      inputPorFormat: '请输入EDI报文类型',
      reportTypeRequireValidate: '请选择报文类型',
      deleteReasonRequireValidate: '请选择更改舱单原因',
      loadShipTimeRequireValidate: '请输入装船时间',
      changeResonRequireValidate: '请输入变更原因描述',
      changeContactNameRequire: '请输入变更申请联系人姓名',
      changeContactTelRequireValidate: '请输入变更申请联系人电话',
      originalReleaseShipVoyageName: '原放行船名航次',
      viewEdiFeedBack: '查看EDI反馈',
      uploadDgDeclare: '上传危险品申报单',
      uploadChineseMSDS: 'SHIPER盖章MSDS中文版',
      chineseMSDS: '中文 MSDS',
      dgDeclare: '危险品申报单',
      uploadSuccess: '危险品申报单上传成功',
      uploadChineseMSDSSuccess: 'SHIPER盖章MSDS中文版上传成功'
    },
    searchFile: {
      title: '文件查询',
      companyName: '公司名称',
      fileName: '文件名',
      port: '港口',
      resetButton: '重置',
      searchButton: '查询',
      attachment: '附件',
      updateTime: '更新时间',
      portNameCn: '港口中文名',
      portName: '港口英文名'
    },
    ediFeedBack: {
      vvl: '船名航次',
      portCode: '港口',
      importTime: '导入时间',
      vesselAndVoyageNotNull: '船名&航次不能为空',
      blNoNotEmpty: '提单号不能为空',
      vesselCode: '船舶代码',
      voyageNo: '航次',
      voyageLeg: '航段',
      blNo: '提单号',
      content: '反馈内容',
      createdDate: '创建时间',
      containerNo: '箱号',
      messageId: 'Message Id',
      functionCode: 'Function Code',
      messageType: '报文类型',
      imoCode: 'IMO',
      responseType: '反馈类型',
      sendTime: '发送日期',
      portCodeNotNull: '港口不能为空',
      checkOneRecord: '请选中一条记录',
      missingData: '所选的记录缺少数据',
      btnGuidebook: 'EDI发送失败处理指南',
      checkOneData: '请至少选择一条记录',
      YPDeleteCNTAO: '预配删除报文(青岛)',
      customsCode: '关区代码',
      changeApplicantName: '变更申请人姓名',
      changeApplicantTel: '变更申请人联系方式',
      changeReason: '变更原因',
      validCustomsCode: '请选择关区代码',
      validChangeApplicantName: '请输入变更申请人姓名',
      validChangeApplicantTel: '请输入变更申请人联系方式',
      validChangeReason: '请输入变更原因',
      deleteSuccess: '报文成功上传到ftp!',
      delFail: '报文上传到ftp失败!'
    },
    sendFailGuidebook: {
      title: '主要反馈内容及处理建议（其他反馈内容，请咨询客服）',
      tabTitle1: '1. 舱单运输工具无预报动态，海关审核不通过',
      tabTitle2: '2. 报文不符合填制规范，海关审核不通过',
      tabTitle3: '3. 无回执发送不成功',
      tabTips1: '预配发送时间过早/关区错误。发舱单前可先在海关平台查询船舶动态，一般在船开前72小时内发舱单，在正确关区/相应时间内重发舱单即可。',
      tabTips2: '反馈内容英文为详细解释。多为收发通的电话邮箱等内容录入不规范，注意字符不能太长，控制在一行以内，' + '电话以纯数字形式录入，且电话邮箱企业代码等信息必须一一对应，不得用点等其他字符代替。或为铅封号填写不对，需要箱封号一一对应，录完整的一个铅封，正确填写。',
      tabTips3: '收发通品名地址字段超过256个字符、收发通品名地址有特殊字符，收发通客户联系电话传真字符过长，' + '电话/传真字段有特殊字符（）+ - 等、封号箱号后有空格、危险品信息栏没填写联系人电话。'
    }
  }
};